/* eslint-disable prettier/prettier */
import initHistoryblock from './historyblock'

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import initCalendar from './calendar'
import initContentPage from './content-page'
 
Alpine.plugin(collapse)
Alpine.start()

if (document.querySelector('.history-block'))
{
    initHistoryblock()
}

if (document.querySelector('.calendar-block'))
{
    initCalendar()
}

if (document.querySelector('.content-page--container.with-navigation'))
{
    initContentPage()
}